import React from 'react';
import PossibleMerge from '../../../../../../mapComponents/Markers/Dispatch/PossibleMerge';
import StyledToolTip from '../../../../../../common/StyledToolTip';
import { withStyles, withTheme, IconButton } from '@material-ui/core';
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline';
import { isGroupedPickups } from '../../GroupPickup/utils';

const styles = (theme) => ({
  iconButton: {
    padding: 0,
    color: theme.gridTextColor
  },
  paddingLeft: {
    paddingLeft: '28px'
  }
});

const RendererIcon = withStyles(styles)(({
  classes,
  title,
  icon,
  onClick,
  paddingLeft = false
}) => {
  return (
    <StyledToolTip title={title}>
      {onClick ? (
        <div className={paddingLeft ? classes.paddingLeft : ''}>
          <IconButton classes={{ root: classes.iconButton }} onClick={onClick}>
            {icon}
          </IconButton>
        </div>
      ) : (
        <div>{icon}</div>
      )}
    </StyledToolTip>
  );
});

const PickupIndicatorIconRenderer = ({ context, theme, data }) => {
  const duplicatePickups = context.getSelectedPickupsDuplicate(data.pickupId);
  const shouldShowUnmergeIcon = data.groupId && isGroupedPickups(data) && !data.isCompleted;
  // Show minus icon for nested pickups within groups
  if (shouldShowUnmergeIcon) {
    return (
      <RendererIcon
        title="Unmerge Pickup"
        icon={<RemoveCircleOutlineIcon color={theme.gridTextColor} />}
        onClick={context.handleUnGroupPickupClick([data])}
        paddingLeft={true}
      />
    );
  }

  if (Boolean(duplicatePickups?.length)) {
    return (
      <RendererIcon
        title="Possible merge"
        icon={<PossibleMerge color={theme.iconColor} />}
        onClick={context.handlePossibleMergeClick(data.pickupId?.toLowerCase())}
      />
    );
  }
  return data.isMergedPickup ? (
    <RendererIcon
      title={`Merged to ${data.pickupMergedTo}`}
      icon={<i className="icon-merge-routes" />}
    />
  ) : null;
};

export default withTheme()(PickupIndicatorIconRenderer);
